import { HTMLAttributes, useLayoutEffect, useMemo } from "react"

import { Outlet, useParams } from "react-router"

import * as m from "motion/react-m"

import { s } from "@/utils/i18n"

import useHistory from "@/hooks/useHistory"
import useModal from "@/hooks/useModal"

import Link from "@/components/Link"

import CloseIcon from "@/icons/Close"

export default function ModalLayout({ parent, ...props }: { parent?: string } & HTMLAttributes<HTMLDivElement>) {
  const { lastPage: _lastPage } = useHistory()
  const params = useParams()
  const { setIsModalActive } = useModal()

  useLayoutEffect(() => {
    document.body.style.overflow = "hidden"
    setIsModalActive(true)
    return () => {
      document.body.style.overflow = ""
      setIsModalActive(false)
    }
  }, [setIsModalActive])

  const substitutedLink = useMemo(() => {
    let link = parent || ""
    Object.entries(params).forEach(([key, value]) => {
      if (!value) {
        return
      }
      link = link.replace(`:${key}`, value)
    })
    return link
  }, [parent, params])

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className="fixed inset-0 z-40 flex flex-col items-center overflow-auto bg-black/10 backdrop-blur-md"
    >
      <Link href={parent ? substitutedLink : _lastPage || `/calendar`} className="pointer-events-auto absolute inset-0">
        <span className="sr-only">{s`Return to previous page`}</span>
      </Link>
      <div className="min-h-5 grow" />
      <div className="mx-auto max-w-full px-5" style={{ width: 900 }}>
        <div
          className="relative flex flex-col overflow-auto rounded-3xl bg-white px-5 pt-4 shadow-lg dark:bg-black"
          style={{ maxHeight: "90dvh", minHeight: "40dvh" }}
          {...props}
        >
          <div className="absolute top-4 right-5 z-20">
            <Link
              href={parent ? substitutedLink : _lastPage || `/calendar`}
              className="hover:bg-concrete dark:hover:bg-slate pointer-events-auto absolute top-0 right-0 z-20 rounded-md p-1 transition"
            >
              <CloseIcon width="20" height="20" className="opacity-60" />
              <span className="sr-only">{s`Return to previous page`}</span>
            </Link>
          </div>
          <Outlet />
        </div>
      </div>
      <div className="min-h-5 grow" />
    </m.div>
  )
}
